import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentPlannerProfileReportFacade } from './shipment-planner-profile-report.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileReportGuard {
  constructor(private shipmentPlannerProfileReportFacade: ShipmentPlannerProfileReportFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return checkStoreState(this.shipmentPlannerProfileReportFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentPlannerProfileReportFacade);
  }
}
